const getters = {
    transactions: (state) => state.transactions,    
    loading: state => state.loading
};

export default getters;